<div class="ir-item-line th-filter" *ngIf="actionPlan?.responsibleList?.length">
  <div (click)="setOrderBy('side')" class="ir-item-cell s7 clickable">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ i18nPrefix + '.detail.category.header' | translate: { default: 'Side' } }}
    </span>
  </div>
  <div (click)="setOrderBy('status')" class="ir-item-cell s3 clickable right">
    <span>
      <i class="material-icons" *ngIf="direction === 'asc'">arrow_drop_up</i>
      <i class="material-icons" *ngIf="direction === 'desc'">arrow_drop_down</i>
      {{ i18nPrefix + '.detail.status.header' | translate: { default: 'Status' } }}
    </span>
  </div>
</div>
<div class="ir-content-flow" [ngClass]="actionPlan?.responsibleList?.length ? 'has-filter' : ''">
  <div *ngIf="actionPlan?.responsibleList">
    <div
      class="ir-item-line th-section clickable"
      (click)="openResponsible(item)"
      *ngFor="let item of actionPlan.responsibleList | orderBy: orderByFieldName:direction | searchBy: query"
    >
      <div class="ir-item-cell s7">
        <span>{{ i18nPrefix + '.detail.category.side' + item.side | translate: { default: item.side } }}</span>
      </div>
      <div class="ir-item-cell s3 right statut">
        <i *ngFor="let icon of item.icons" class="material-icons {{ icon.classes }}">{{
          icon.count !== 0 ? icon.name : ''
        }}</i>
        <span>{{ item.getProgression() }} %</span>
      </div>
    </div>
  </div>
  <div class="ir-item-empty ir-mv8" *ngIf="actionPlan?.responsibleList?.length == 0">
    <p>
      <span>No items</span>
    </p>
  </div>
</div>
